import type { RootState } from "@/lib/types/state";

/**
 * Checks if the user is scheduling on behalf of a provider-patient relationship
 */
export const selectIsSchedulingOnBehalfOf = (state: RootState): boolean => {
  return Boolean(state.calendar?.onBehalfOfPatient);
};
